type AccessTokenPayload = {
  id?: string;
  exp?: number;
};

function readPayload(token: string): AccessTokenPayload | null {
  const part = token.split('.')[1];

  if (!part) {
    return null;
  }

  try {
    const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(json) as AccessTokenPayload;
  } catch {
    return null;
  }
}

export function getUserIdFromAccessToken(token: string) {
  const id = readPayload(token)?.id;
  return typeof id === 'string' ? id : null;
}

export function isAccessTokenExpired(token: string, skewSeconds = 10) {
  const exp = readPayload(token)?.exp;

  if (typeof exp !== 'number') {
    return true;
  }

  return Date.now() / 1000 >= exp - skewSeconds;
}
